import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from "rxjs";
import { Acquisto, Filter } from "../_Models";
import { ServerPaginationService } from "../../shared/_services/server-pagination.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Permission } from "../../Login/_guards/Permission";
import { ApiRestService } from "../api-rest.service";
import { ClassicType } from "../../shared/models/ClassicType";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { AcquistiEditComponent } from "../acquisti-edit/acquisti-edit.component";
import { Azienda } from "../../Admin/models/Azienda";
import { ApiRestService as ClientiApiRestService } from "../../Admin/_service/api-rest.service";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-acquisti-list',
  templateUrl: './acquisti-list.component.html'
})
export class AcquistiListComponent implements OnInit {
  environment = environment;
  subscriptions: Subscription = new Subscription();
  page = 1;
  pageSize = 50;
  pagesizeserver = 4
  newpagegenerated = 1;
  List: Acquisto[] = [];
  collectionSize: number = 0;
  Stati: ClassicType[];
  StatiSelezionati: ClassicType[] = [{ id: "T", label: "Tutte" }];
  DropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label'
  };
  Fornitori: Azienda[] = [];
  FornitoriSelezionati: Azienda[] = [];
  clientiDropdownSettings: IDropdownSettings = {
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'nominativo',
    allowSearchFilter: true,
  };
  @Input() hasFiltri: boolean = true;
  @Input() isAddEnabled: boolean = true;
  @Input() isEditEnabled: boolean = true;
  @Input() Filtri: Filter = { page: 1, size: 10, stato: "T", periodo: false, anno: new Date().getFullYear() };
  SelectAll: boolean;
  stampe: any[] | undefined;


  constructor(
    private modalService: NgbModal,
    private paginationService: ServerPaginationService,
    public permission: Permission,
    private apirestservice: ApiRestService,
    private clientiApiRest: ClientiApiRestService,

  ) { }

  ngOnInit(): void {
    this.refreshTable(1);
    this.clientiApiRest.getListaAziende({ ruolo: "F", page: 0, size: 10 }).subscribe(data => {
      this.Fornitori = data?.data;
      if (data?.data?.length == 1)
        this.FornitoriSelezionati = data?.data;
    });
    this.apirestservice.PrimaNotaAcquistiStati().subscribe(data => {
      this.Stati = data ?? [];
      this.StatiSelezionati = [this.Stati?.find(x => true)];
    })
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page: number) {

    if (this.Filtri?.inizio && !this.Filtri?.fine)
      this.Filtri.fine = this.Filtri?.inizio;
    this.Filtri.fornitori = this.FornitoriSelezionati.map(x => x.id);

    this.Filtri.size = this.pagesizeserver * this.pageSize;
    this.Filtri.page = (page - 1) / this.pagesizeserver + 1;
    this.Filtri.stato = this.StatiSelezionati?.length > 0 ? this.StatiSelezionati[0]?.id : undefined;
    if (this.Filtri.stato && this.Stati)
      this.apirestservice.PrimaNotaAcquistiList(this.Filtri).subscribe(data => {
        this.collectionSize = data?.total;
        this.List = data?.data;
        this.stampe = data?.stampe;
      });
  }

  Edit(item?: Acquisto) {
    let modale = this.modalService.open(AcquistiEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<AcquistiEditComponent>modale.componentInstance).isModal = true;
    (<AcquistiEditComponent>modale.componentInstance).acquisto = item ?? new Acquisto();
    (<AcquistiEditComponent>modale.componentInstance).Saved.subscribe(() => this.refreshTable(1));
  }
  delete(item: Acquisto) {
    if (confirm("Sei sicuro di voler eliminare questo elemento?")) {
      this.apirestservice.PrimaNotaAcquistiDelete({ id: item.id }).subscribe(() => this.refreshTable(this.newpagegenerated));
    }
  }
  CheckIfAllSelected() {
    this.SelectAll = this.List.every(function (item: any) {
      return item.isSelected == true;
    })
  }
  checkUncheckAll() {
    this.List?.forEach(spedizione => spedizione.isSelected = this.SelectAll)
  }

  FornitoreChanged() {
    this.refreshTable(1);
  }
  orderByFornitore() {
    var orderParam = 'orderByFornitore'
    this.Filtri[orderParam] = this.Filtri[orderParam] == 'asc' ? 'desc' : 'asc';
    this.refreshTable(1);
  }
}